import ConfigurationItemsService from '@/api/admin/configurations.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
    configurationModel: {},
  },
  getters: {
    getAdminConfigurations: state => state.table,
    getConfigurationModel: state => state.configurationModel,
  },
  actions: {
    async getAdminConfigurations({ commit }) {
      const configurations = await ConfigurationItemsService.getAdminConfigurations()
      commit('SET_CONFIGURATIONS', configurations)
    },
  },
  mutations: {
    SET_CONFIGURATIONS(state, configurations) {
      state.table.rows = configurations
    },
    SET_CONFIGURATION_MODEL(state, model) {
      state.configurationModel = model
    },
  },
}
